import { Grid } from '@mui/material';
import { useState } from 'react';

import Button from 'components/ui/Button';

const BottomButtons = ({
  backColor = 'info',
  backTitle = 'Back',
  submitTitle = 'Finish',
  sideContent,
  isDisabled,
  isSubmitting,
  onBack,
  onSubmit,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setIsLoading(true);

    if (onSubmit) await onSubmit();

    setIsLoading(false);
  };

  return (
    <Grid item display="flex" xs={12} justifyContent="flex-end" mt={3}>
      {sideContent && sideContent}
      {onBack && (
        <Button color={backColor} type="button" onClick={onBack}>
          {backTitle}
        </Button>
      )}
      {onSubmit && (
        <Button
          disabled={isDisabled}
          isLoading={isLoading || isSubmitting}
          variant="contained"
          sx={{ ml: 1 }}
          type="submit"
          onClick={handleSubmit}
        >
          {submitTitle}
        </Button>
      )}
    </Grid>
  );
};

export default BottomButtons;
